import React from 'react'
import { Tab, Table, Tabs } from 'react-bootstrap'
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from 'react-vertical-timeline-component'
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import PersonFill from 'react-bootstrap-icons/dist/icons/person-fill'
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import PersonCheck from 'react-bootstrap-icons/dist/icons/person-check'
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import Star from 'react-bootstrap-icons/dist/icons/star'
import 'react-vertical-timeline-component/style.min.css'
import { ServicePrice, Treatment, Question } from '../interfeces'

interface Props {
  treatment: Treatment
  questions: Array<Question>
}

const ServiceTable: React.FC<Props> = ({
  treatment,
  questions,
}: Props) => {
  return (
    <div className="row">
      <div className="col-12">
        <Tabs defaultActiveKey="prices">
          <Tab eventKey="prices" title="Prices">
            <a
              className="btn btn-outline-maincolor
                btn-sm make-appointment-top"
              href="https://booksy.com/en-gb/instant-experiences/widget/61001?instant_experiences_enabled=true&ig_ix=true&is_fb=1&fbclid=IwAR2p-lXjX6nvc-eD8ZQzHfOI9gXvf1O9J-HESKw62yYQR_VpYMfaU5QS4qo"
              type="submit"
              rel="noreferrer"
              target="_blank"
            >
              prices
            </a>
          </Tab>
          <Tab eventKey="process" title="TREATMENT Process">
            <VerticalTimeline>
              <VerticalTimelineElement
                className="vertical-timeline-element--work"
                date=""
                iconStyle={{
                  background: 'rgb(33, 150, 243)',
                  color: '#fff',
                }}
                icon={<PersonCheck />}
              >
                <h3 className="vertical-timeline-element-title">
                  Free Consultation
                </h3>
                <h4 className="vertical-timeline-element-subtitle"></h4>
                <p></p>
              </VerticalTimelineElement>
              <VerticalTimelineElement
                className="vertical-timeline-element--education"
                date={treatment.duration}
                iconStyle={{
                  background: 'rgb(255,48,119)',
                  color: '#fff',
                }}
                icon={<PersonFill />}
              >
                <h3 className="vertical-timeline-element-title">Treatment</h3>
                <h4 className="vertical-timeline-element-subtitle"></h4>
                <p>{treatment.session}</p>
              </VerticalTimelineElement>
              <VerticalTimelineElement
                className="vertical-timeline-element--education"
                date={treatment.results}
                iconStyle={{
                  background: 'rgb(51,186,4)',
                  color: '#fff',
                }}
                icon={<Star />}
              >
                <h3 className="vertical-timeline-element-title">
                  POST TREATMENT
                </h3>
                <h4 className="vertical-timeline-element-subtitle"></h4>
                <p></p>
              </VerticalTimelineElement>
            </VerticalTimeline>
          </Tab>
          <Tab eventKey="question" title="Frequently Asked Questions">
            {questions.map((ob: any, index: any) => (
              <div key={index}>
                <p className="font-weight-bold">{ob.question}</p>
                <p>{ob.answer}</p>
              </div>
            ))}
          </Tab>
          <Tab eventKey="book" title="Book Appointment">
            <button
              href="https://booksy.com/en-gb/instant-experiences/widget/61001?instant_experiences_enabled=true&ig_ix=true&is_fb=1&fbclid=IwAR2p-lXjX6nvc-eD8ZQzHfOI9gXvf1O9J-HESKw62yYQR_VpYMfaU5QS4qo"
              className="btn btn-outline-maincolor
                btn-sm make-appointment-top"
            >
              book now
            </button>
          </Tab>
        </Tabs>
      </div>
    </div>
  )
}

export default ServiceTable
